export default __webpack_public_path__ + "static/media/linkedin-icon-2.32e20978.svg";